import React, {useState} from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Industries(props) {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getActiveClass = (index, className) =>
        toggleState === index ? className : "";

    return (
        <div className="seriveces_industries p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
                        <div className="example" data-text="We Serve">
                            <h2>Industries We Serve</h2>
                        </div>
                        <p className="strong">TekRevol has expertise in building cloud-native solutions for these diverse industries.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="deskstop_version">
                        <div className="process_icons">
                            <ul>
                                <li className={`tabs ${getActiveClass(1, "active-tabs")}`}
                                    onClick={() => toggleTab(1)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                    </div>
                                    Healthcare
                                </li>
                                <li className={`tabs ${getActiveClass(2, "active-tabs")}`}
                                    onClick={() => toggleTab(2)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                    </div>
                                    Real Estate
                                </li>

                                <li className={`tabs ${getActiveClass(3, "active-tabs")}`}
                                    onClick={() => toggleTab(3)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                    </div>
                                    Gaming
                                </li>
                                <li className={`tabs ${getActiveClass(4, "active-tabs")}`}
                                    onClick={() => toggleTab(4)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                    </div>
                                    Ecommerce
                                </li>
                                <li className={`tabs ${getActiveClass(5, "active-tabs")}`}
                                    onClick={() => toggleTab(5)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                    </div>
                                    Lifestyle
                                </li>

                            </ul>

                            <div className={toggleState === 1 ? 'content d-block' : "content d-none"}>
                                <p>DevOps solutions in the healthcare and wellness industry allow ample storage and processing workloads. The implementations help secure massive patient data and make it migration-ready in real time. TekRevol has expertise in building Electronic Health Records, enterprise medical imaging, and clinical decision support systems as use cases boosting the healthcare functionalities and features.</p>
                            </div>
                            <div className={toggleState === 2 ? 'content d-block' : "content d-none"}>
                                <p>Real estate has shown some transformative use cases of most emerging technologies with unmatchable growth. DevOps and Agile are among those techs that can help real estate secure documentation and preserve agreements and transaction data. With this, TekRevol can help you deploy the right DevOps strategies for your property business</p>
                            </div>
                            <div className={toggleState === 3 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol has witnessed gaming companies yield the benefits of DevOps as early adopters. Build and run scalable games and deliver game products faster with DevOps strategies. Test them in real-time, improve and deploy on the way to the quickest monetization.</p>
                            </div>
                            <div className={toggleState === 4 ? 'content d-block' : "content d-none"}>
                                <p>With the percentage of shoppers switching to online channels for basics to luxuries, it requires growing ecommerce and retail companies to plunge into most emerging technologies. Strategies like agile and DevOps can help achieve conversion targets faster with ecommerce platforms that are built faster and run better, and cater to the needs of different stakeholders – vendors and customers efficiently.</p>
                            </div>
                            <div className={toggleState === 5 ? 'content d-block' : "content d-none"}>
                                <p>DevOps consulting at TekRevol can revolutionize product and solution delivery in the lifestyle niche. From content consumption to smart home automation solutions, entrepreneurs in this niche can provide an exceptional experience to their stakeholders.</p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mobile_version">
                        <div className="tekrevol_mobile_accordion_side">
                            <Accordion
                                defaultActiveKey="1">
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                        Healthcare
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>DevOps solutions in the healthcare and wellness industry allow ample storage and processing workloads. The implementations help secure massive patient data and make it migration-ready in real time. TekRevol has expertise in building Electronic Health Records, enterprise medical imaging, and clinical decision support systems as use cases boosting the healthcare functionalities and features.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                        Real Estate
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Real estate has shown some transformative use cases of most emerging technologies with unmatchable growth. DevOps and Agile are among those techs that can help real estate secure documentation and preserve agreements and transaction data. With this, TekRevol can help you deploy the right DevOps strategies for your property business.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                        Gaming
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol has witnessed gaming companies yield the benefits of DevOps as early adopters. Build and run scalable games and deliver game products faster with DevOps strategies. Test them in real-time, improve and deploy on the way to the quickest monetization.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                        Ecommerce
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>With the percentage of shoppers switching to online channels for basics to luxuries, it requires growing ecommerce and retail companies to plunge into most emerging technologies. Strategies like agile and DevOps can help achieve conversion targets faster with ecommerce platforms that are built faster and run better, and cater to the needs of different stakeholders – vendors and customers efficiently.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                        Lifestyle
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>DevOps consulting at TekRevol can revolutionize product and solution delivery in the lifestyle niche. From content consumption to smart home automation solutions, entrepreneurs in this niche can provide an exceptional experience to their stakeholders.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Industries;